module.exports = __webpack_public_path__ + "img/icom3.103937f4.png";